import {
  FlexCenter,
  NumberDisplay,
  SkeletonLine,
  TextBody,
} from "@opensea/ui-kit"
import { LocalGasStationFilled } from "@opensea/ui-kit/icons"
import { bn } from "@opensea/utils"
import { useAccount } from "@opensea/wallet"
import { useTranslations } from "next-intl"
import { useEstimateFeesPerGas } from "wagmi"

export function PageFooterGwei() {
  const { chainId } = useAccount()
  const t = useTranslations("PageFooterGwei")
  const result = useEstimateFeesPerGas({
    chainId: chainId || 1,
    formatUnits: "gwei",
  })

  if (!result.data?.maxFeePerGas) {
    return <SkeletonLine className="h-5 w-[76px]" />
  }

  return (
    <FlexCenter className="gap-1 text-text-secondary">
      <LocalGasStationFilled size={14} />
      <TextBody size="xs">
        <NumberDisplay
          // Wei to gwei
          display="quantity"
          value={bn(result.data.maxFeePerGas).div(1e9)}
        />{" "}
        {t("gwei")}
      </TextBody>
    </FlexCenter>
  )
}
